module.exports = __webpack_public_path__ + "files/26bb8f46a6deec8a57297e588d996639.png";